export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const GET_CATALOG = 'GET_CATALOG';
export const GET_CATALOG_LOADING = 'GET_CATALOG_LOADING';
